import React from 'react';
import { resources } from '../../constants';
import Logo from '../Logo/Logo';
import ThemedText from '../theme/ThemedText';
import ThemeLogo from '../theme/ThemeLogo';
import './action.scss';
import { Flexbox } from './Flexbox';

const SearchBar = ({ placeholder = 'Search', value, onChange, handleKeyDown, style, searchData, handleSearchClick }) => {
  return (
    <Flexbox className='searchbar_container' gap='0.25rem' onKeyDown={handleKeyDown} style={style}>
      <Flexbox className='searchbar_container__logo'>
        <ThemeLogo icon={'search'} />
      </Flexbox>
      <input className='searchbar_container__input' placeholder={placeholder} value={value} onChange={onChange} />
      {searchData && searchData?.length > 0 && (
        <ul className='search_results'>
          {searchData?.map((result, index) => (
            <li key={`searchresults_${index}`} onClick={handleSearchClick}>
              <Logo width={'1.25rem'} height={'1.25rem'} borderRadius='50%' src={resources.img.getAvatar(result?.address)} />
              <ThemedText.P> {result?.name}</ThemedText.P>
            </li>
          ))}
        </ul>
      )}
    </Flexbox>
  );
};

export default SearchBar;
